import './monitoring/sentry';
import * as Sentry from '@sentry/react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { Provider } from 'react-redux';
import store from './store/store';
import { LoadScript } from '@react-google-maps/api';
import { GOOGLE_API_KEY } from '@src/utils/constants';
import { ThemeProvider } from './ThemeProvider';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './authConfig';
import SomethingWentWrong from '@component/SomethingWentWrong/SomethingWentWrong';
import { LoaderComponent } from '@component/LoaderComponent/LoaderComponent';
import { reloadOnce } from '@utils/lazyWithRetry';

const msalInstance = new PublicClientApplication(msalConfig);

// A chunk Vite preloads with a lazy route (JS or CSS) is missing — the build
// was redeployed under this tab. Reload once into the new build.
window.addEventListener('vite:preloadError', (event) => {
  if (reloadOnce()) event.preventDefault();
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <BrowserRouter
    future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
  >
    <Provider store={store}>
      <LoadScript
        googleMapsApiKey={GOOGLE_API_KEY}
        libraries={['places', 'maps', 'geocoding', 'geometry']}
        loadingElement={<LoaderComponent />}
      >
        <ThemeProvider>
          <MsalProvider instance={msalInstance}>
            <Sentry.ErrorBoundary fallback={<SomethingWentWrong />}>
              <App />
            </Sentry.ErrorBoundary>
          </MsalProvider>
        </ThemeProvider>
      </LoadScript>
    </Provider>
  </BrowserRouter>
);
